export default __webpack_public_path__ + "static/media/HK.3f175c01.png";